import {useDispatch,useSelector} from 'react-redux'
import {
	selectExerciseType,
	selectExerciseId,
	selectWorkoutId,
	selectSetIdx,
	toggleShow,
	selectShow,
	selectType,
} from './slice'

import {useEvent} from '../../hooks/events'
import {extractExerciseFromRoutine} from '../../state/events'


//!!! need to use global scope for these !!!
let exerciseRecorderMediaStream = false
let exerciseRecorderMediaRecorder = false
export const useRecorder = ()=>{
	const show = useSelector(selectShow)
	const exercise_type = useSelector(selectExerciseType)
	const workout_id = useSelector(selectWorkoutId)
	const exercise_id = useSelector(selectExerciseId)
	const setIdx = useSelector(selectSetIdx)
	//select exercise & workout data
	const workout = useEvent('workout',workout_id)
	const exercise = extractExerciseFromRoutine(workout.routine,exercise_type,exercise_id)
	const set = exercise?.set_data[setIdx]
	return {show,workout,exercise,toggleShow,set,setIdx}
}